module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8019.fa950690.png";